/**
 * API client for the Style Library endpoints.
 */

import { getConfiguredApiBase, getAuthToken } from './client'

export interface StyleSummary {
  id: string
  name: string
  prompt: string
  use_reference_in_generation: boolean
  reference_image_count: number
  tags: string[]
  thumbnail_url: string | null
  preview_image_urls: string[]
}

export interface StyleDetail {
  id: string
  name: string
  prompt: string
  reference_images: string[]
  use_reference_in_generation: boolean
  tags: string[]
  thumbnail_url: string | null
  preview_image_urls: string[]
}

export interface StyleListResponse {
  styles: StyleSummary[]
}

async function stylesRequest<T>(path: string): Promise<T> {
  const baseUrl = getConfiguredApiBase()
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }
  const authToken = await getAuthToken()
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`
  }
  const response = await fetch(`${baseUrl}${path}`, { headers })
  if (!response.ok) {
    throw new Error(`Failed to fetch styles: ${response.statusText}`)
  }
  return response.json()
}

export async function listStyles(): Promise<StyleListResponse> {
  return stylesRequest<StyleListResponse>('/styles')
}

export async function getStyle(id: string): Promise<StyleDetail> {
  return stylesRequest<StyleDetail>(`/styles/${id}`)
}

/**
 * Build a full URL for a style image path (e.g. "/styles/2d-comic/images/thumbnail.jpg").
 */
export function getStyleImageUrl(relativePath: string): string {
  const baseUrl = getConfiguredApiBase()
  return `${baseUrl}${relativePath}`
}
